import React, { Component } from 'react'
import { connect } from 'react-redux'
import styles from '../../../styles/3ds2/main.module.css'
import CavvPurchaseRecSample from '../samples/CavvPurchaseRecSample'
import Purchase3DS2RecurSample from '../samples/Purchase3DS2RecurSample'
import { makeCavvPurchaseRecRequest } from '../../../actions/threeDSTwoActions'
import { updateOrderId } from '../../../actions/commonActions'
import { _3DS2 } from '../../../actions/types'


class Purchase3DSRec extends Component {
    state = {
        topRef: React.createRef()
    }

    generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    getOrderId() {
        const { order_id } = this.props;
        if(order_id === "none")
            return `"Test" + DateTime.Now.ToString("yyyyMMddhhmmss")`;
        else
            return `"${order_id}"`;
    }

    async onCavvPurchaseRecPress() {
        const { cavvPurchaseRecSuccess, loading } = this.props;
        const { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci } = this.props;

        if(loading || cavvPurchaseRecSuccess || eci === cavv) return;

        if(order_id === 'none') {
            const newOrderId = await this.generateOrderId();
            this.props.updateOrderId({ featureId: _3DS2, orderId: newOrderId });
        }
        const cavvPurchaseRecRequest = { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci };
        this.props.makeCavvPurchaseRecRequest(cavvPurchaseRecRequest);
    }

    renderBtn() {
        const { loading, cavvPurchaseRecSuccess, eci, cavv } = this.props;

        if(!(loading || cavvPurchaseRecSuccess || eci === cavv)) {
            return (
                <div style={{marginLeft: '20%'}} className={"requestButton"} onClick={() => this.onCavvPurchaseRecPress()}>
                    Cavv Purchase Recur Request
                </div>
            );
        }
        else {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'left'}}>
                     <div className="disabledButton">
                        Cavv Purchase Recur Request
                     </div>
                     <i style={{marginLeft: '1vw', fontSize: '0.8rem', color: 'red'}}>* To make this request you need to get cavv and eci (crypt type) by making 3DS Auth request.</i>
                </div>
            );
        }
    }

    renderInteractiveTool() {
        const { leftContents } = styles;

        return (
            <div className={leftContents}>
                <div ref={this.state.topRef} style={{ paddingLeft: '1vw', paddingRight: '2vw', marginBottom: '10%'}}>
                    <h3>Sample Purchase with 3-D Secure and Recurring Billing</h3>
                    <CavvPurchaseRecSample />
                    {this.renderBtn()}
                </div>
            </div>
        );
    }

    renderDocument() {
        // const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <div ref={this.state.topRef}>
                    <span className="stepPageTitle"><b>Purchase with 3-D Secure and Recurring Billing</b></span>
                    
                    <div className="warning">
                        <p><b>WARNING: </b> Moneris strongly discourages the use of frames as part of a 3-D Secure implementation, and cannot guarantee their reliability when processing transactions in the production environment.</p>
                    </div>
                    <p>The example below illustrates the Purchase with 3-D Secure when also sending the Recurring Billing Info object in the transaction.</p>
                </div>

                <Purchase3DS2RecurSample />
            </div>
        )
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderInteractiveTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci } = state.threeDSTwo.main.config;
    const { loading, cavvPurchaseRecSuccess, cavvLookupSuccess } = state.threeDSTwo.main;
    const { mode } = state.common.sideNav;
    const { selection } = state.threeDSTwo.stepsList;
    return { cavvPurchaseRecSuccess, cavvLookupSuccess, selectedStep: selection, mode, loading, storeId, apiToken, order_id, pan, expdate, amount, cavv, eci, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {makeCavvPurchaseRecRequest, updateOrderId})(Purchase3DSRec)
